import {useEffect, useState} from "react";
import {
    buildUpcomingSessions,
    buildNextUpcomingSessionEvents
} from "../helpers/SessionHelper";

const CURRENT_SESSION_POLLING_RATE_IN_MILLISECONDS = 1000;

export function useSessionPolling(timeslotEvents, timeslots) {
    const [upcomingSessions, setUpcomingSessions] = useState(undefined);
    const [time, setTime] = useState(Date.now());

    useEffect(() => {
        const upcomingSessionEvents = buildNextUpcomingSessionEvents(timeslotEvents);
        const upcomingSessions = buildUpcomingSessions(upcomingSessionEvents, timeslots);

        setUpcomingSessions(upcomingSessions);
    }, [time, timeslotEvents, timeslots]);

    useEffect(() => {
        const interval = setInterval(() => setTime(Date.now()), CURRENT_SESSION_POLLING_RATE_IN_MILLISECONDS);
        return () => clearInterval(interval);
    }, []);

    return {
        time,
        upcomingSessions
    };
}
